// extracted by mini-css-extract-plugin
export default {"wrap":"OrderListRow_wrap__VHuQj","imgWrap":"OrderListRow_imgWrap__FeqcM","border":"OrderListRow_border__IjlQQ","trackButton":"OrderListRow_trackButton__Xl5Xq"};